import React from "react";
import Header from "./components/Header";
import Tabs from "./components/Tabs";
import "./index.css";

export default function App() {
  return (
    <div className="container">
      <Header />
      <Tabs />
      {/* <Footer /> */}
    </div>
  );
}
